import { useParams, useNavigate } from "react-router-dom"; 
import { useEffect, useState } from "react";
import apiClient from "../Api/apiConfig"; // ⭐ Utilisation de la configuration API centralisée
import "../styles/ValidateEmailPage.css";

export default function ValidateEmailPage() {
 const { token } = useParams(); 
 const navigate = useNavigate();
 const [validationStatus, setValidationStatus] = useState("loading");
 const [errorMessage, setErrorMessage] = useState("");

 useEffect(() => {
  if (!token || typeof token !== "string" || token.length < 10) {
   setValidationStatus("error");
   setErrorMessage("Token manquant ou invalide. Vérifiez le lien.");
   return;
  }

  const controller = new AbortController();
  // Note: Axios/apiClient gère les signaux différemment, 
    // mais nous allons laisser la déclaration du controller ici pour la bonne pratique du cleanup.

  const validateEmail = async () => {
   try {
        // ⭐ CORRECTION : Utilisation de apiClient.post pour hériter de la base URL
        // L'URL relative est : /api/users/validate-email
    const response = await apiClient.post(
            "/users/validate-email", 
            { token }, // Le token est envoyé dans le corps
            { signal: controller.signal } // Passage du signal d'annulation
        );

        // Si apiClient est Axios, il lance une erreur pour les statuts 4xx/5xx, 
        // sinon nous vérifions le statut. Pour la robustesse, on garde la vérification implicite d'Axios.
        
    setValidationStatus("success");

   } catch (error) {
    if (error.name === "AbortError") return; 
        
        // Gérer les erreurs de l'API (404, 400, 500)
    let msg = "Une erreur est survenue lors de la validation.";
    if (error.response) {
            // Erreur renvoyée par le serveur (ex: 404, 400). Vérifions le message d'erreur JSON du backend.
            const status = error.response.status;
            const data = error.response.data;
            
            if (status === 404) {
                msg = `Erreur 404: La route de validation est introuvable. (Vérifiez votre route Express) : /api/users/validate-email`;
            } else if (data && data.error) {
                msg = data.error; // Utiliser le message d'erreur du backend
            } else {
                msg = `Erreur du serveur (${status}).`;
            }
    } else if (error.message.includes("Failed to fetch")) {
            // Erreur réseau (DNS, CORS, ERR_CERT_COMMON_NAME_INVALID, etc.)
            msg = "Erreur de connexion réseau ou de certificat API. Veuillez réessayer.";
        }

    console.error("❌ Erreur de validation API:", error);
    setValidationStatus("error");
    setErrorMessage(msg);
   }
  };

  validateEmail();

  return () => {
   controller.abort();
  };
 }, [token]);

 const handleRedirect = (path) => navigate(path);

 return (
  <div className="validation-page">
   {validationStatus === "loading" && (
    <div className="loading-message" role="status" aria-live="polite">
     <p>Validation de votre email en cours...</p>
     <span className="loading-spinner" />
    </div>
   )}
   {validationStatus === "success" && (
    <div className="success-message" role="alert">
     <p>✅ Votre email a été validé avec succès !</p>
     <div className="actions">
      <button onClick={() => handleRedirect("/donation")}>Faire un don</button>
      <button onClick={() => handleRedirect("/adhesion")}>Adhérer à l'association</button>
      <button onClick={() => handleRedirect("/")}>OK</button>
     </div>
    </div>
   )}
   {validationStatus === "error" && (
    <div className="error-message" role="alert">
     <p>❌ Une erreur est survenue lors de la validation de votre email.</p>
     <p className="error-detail">{errorMessage}</p>
     <button onClick={() => navigate("/")}>Retour à l'accueil</button>
    </div>
   )}
  </div>
 );
}